module.exports = __webpack_public_path__ + "media/assets/socials/github-859061bf024d5fa989b2af496fa95eaa.svg";